import axios from "axios";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });
client.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("gg_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});
client.interceptors.response.use(r => r, (err) => {
  if (err.response?.status === 403 && err.response?.data?.detail === "Account suspended" && !window.__suspendedToast && !window.location.pathname.startsWith("/suspended")) {
    window.__suspendedToast = true; setTimeout(() => { window.__suspendedToast = false; }, 5000);
    import("sonner").then(({ toast }) => toast.error(localStorage.getItem("gg_lang") === "de" ? "Dein Konto ist gesperrt. Bitte kontaktiere den Support über die Hilfe-Seite." : "Your account is suspended. Please contact support via the Help page."));
  }
  return Promise.reject(err);
});
export default client;
